import React from 'react';
import NavBar from '../../../components/common/navbar';
import SideBar from '../../../components/modules/left_sidebar';
import ReceitasEmCobranca from './ReceitasEmCobranca';

import { withRouter } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons'
import EntityDetails from '../../../components/common/EntityDetails';
import $ from 'jquery'
import RightPopModalForm from '../../../components/common/RightPopModalForm';
import services from '../../../services';
const queryString = require('query-string');
var moment = require('moment')
const Administration = false;

/* Array de configurações estáticas da página*/
const optionMenuArray =
{
    linkData: {
        filters: {
            Tabs: {
                'Nº Processo': [
                    {
                        key: 'numerodeentidade',
                        displayKey: "Número de entidade",
                        inputType: "text"
                    },
                    {
                        key: 'nomedeentidade',
                        displayKey: "Nome de entidade",
                        inputType: "text"
                    },
                ],
                'Nº de correlativo': [
                    {
                        key: 'registerno',
                        displayKey: "Número de correlativo",
                        inputType: "number"
                    }
                ],
                Marca: [
                    {
                        key: 'marca',
                        displayKey: "Marca",
                        inputType: "text"
                    }
                ],
            },
            checkbox: []
        },
        navbarOptionsYear: false,
        tableName: "RotulosOneAvaliação",
        nevdropdown: ["Abertura", "Fecho"],
        nevdroplabel: "",
        nevdropplaceholder: "Aberta",
        popUpTabName: "Consultar Conta",
        // OpenAndCloseCashier: true,
        TitleBartitle: "1ª avaliação",
        prevPageName: "",
        prevPageLink: "",                                                                                                                                                                                                                                                                                           
        currentPath: "rotulos_one_avaliação",
        nevOptionChange: [
            {
                name: 'Emitir Faturas',
                url: 'rotulos_one_avaliação',
                tableName: "FaturasEmitir",
            },
            {
                name: 'Faturas por Liquidar',
                url: 'rotulos_one_avaliação                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             ',
                tableName: "FaturasLiquidar",
            }
        ],
        TitleBarlogo: "auditing",
    }
}



class RotulosOneAvaliação extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = this.setLinkDataMethod();
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {

    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (prevProps) => {
     
        const parsed = this.props.location.state && this.props.location.state.paramoption ||{};
        let prevParsed = prevProps.location.state && prevProps.location.state.paramoption || {}
        console.log("....uuuu",parsed)
        if ( prevParsed.name !== parsed.name && (!parsed.tableName || this.state.search !== window.location.search || this.state.tableName !== parsed.tableName)) {
            this.setState(this.setLinkDataMethod())
        }
    }
    /*  Este método é usado para carregar dados estáticos reletados da página com base nas alterações de url  */
    setLinkDataMethod = () => {
        const parsed = this.props.location.state.paramoption || {};
        let selectOption = { ...optionMenuArray };
        let linkData = selectOption.linkData;
        if (!parsed.name) {
            linkData.prevPageName = "";
            linkData.prevPageLink = "";
            linkData.tableName = "RotulosOneAvaliação"
        }
        parsed.name = parsed.name ? parsed.name : ""
        parsed.url = parsed.url ? parsed.url : ""
        parsed.tableName = parsed.tableName ? parsed.tableName : ""
        if (parsed.name) {
            linkData.prevPageName = parsed.name;
            linkData.prevPageLink = parsed.url;
            linkData.tableName = parsed.tableName;
        }

        return {
            noOption: true,
            popUpForm: null,
            linkData: linkData,
            pageOption: "",
            Tab: null,
            parsed: parsed,
            tableName: linkData.tableName,
            search: window.location.search
        }
    }

    /* Sempre que o usuário alterar qualquer opção do front end, este método irá atualizar o url da página de acordo com essa opção  */

    changeOption = (prevPageName, prevPageLink) => {
        let linkData = { ...this.state.linkData }
        linkData.prevPageName = prevPageName;
        linkData.prevPageLink = prevPageLink;

        this.setState({
            linkData
        })
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        console.log("Render again")
        let topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu
        return (
            <div className="dashboard">
                <NavBar date={new Date()} moduleName="Rotulos" linkData={this.state.linkData} topBarMenuOption={topBarMenu} noOption={this.state.noOption} updateNavDropdown={(_row) => this.updateNavDropdown(_row)} />
                <SideBar Administration={Administration} />
                <div className="container-fluid">
                    <ReceitasEmCobranca
                        date={new Date()}
                        parsed={this.state.parsed}
                        changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                        optionMenuArray={optionMenuArray}
                        linkData={this.state.linkData}
                        trans_methods={this.state.trans_methods}
                        tab={"rotulos_pendentes"}
                    />
                </div>
            </div>

        )
    }
}


export default withRouter(RotulosOneAvaliação);